import React from 'react';

import { IconProps } from '../../../DefaultIcon';

export function ContactGroupsIcon({ className }: IconProps) {
  return (
    <svg
      width="69"
      height="69"
      viewBox="0 0 69 69"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_812_1037)">
        <path
          d="M35.6643 0.41958C35.3287 0.146853 34.9091 0 34.5105 0C34.1119 0 33.6923 0.167832 33.3357 0.41958C25.007 6.98601 0 26.5804 0 26.5804V65.8741H69V26.5804C69 26.5804 43.993 6.98601 35.6643 0.41958Z"
          fill="#00C4B3"
        />
        <path
          d="M51.1259 8.79002H11.2448C9.71335 8.79002 8.47559 9.92289 8.47559 11.3075V67.1327H60.5455V18.1886C56.8742 14.5173 54.8182 12.4404 51.1469 8.76904"
          fill="#FAFBFD"
        />
        <path
          d="M68.9996 26.5806V67.133C68.9996 68.182 68.1605 69.0211 67.1115 69.0211H13.9297L68.9996 26.6015V26.5806Z"
          fill="#D6DBE7"
        />
        <path
          d="M55.0699 69.0001L0 26.5806V67.133C0 68.182 0.839161 69.0211 1.88811 69.0211H55.0699V69.0001Z"
          fill="#EAEDF8"
        />
        <path
          d="M42.8813 43.9091H27.1889C26.8323 43.9091 26.5596 43.6364 26.5596 43.2798C26.5596 42.9231 26.8323 42.6504 27.1889 42.6504H42.8813C43.2169 42.6504 43.5106 42.9231 43.5106 43.2798C43.5106 43.6364 43.2379 43.9091 42.8813 43.9091Z"
          fill="#00416B"
        />
        <path
          d="M51.1255 8.79004L60.5241 18.2096H52.552C51.7548 18.2096 51.1045 17.5593 51.1045 16.7621V8.79004H51.1255Z"
          fill="#00416B"
        />
        <path
          d="M39.923 28.3428C38.3705 29.3917 36.5034 30.0001 34.5104 30.0001C32.5174 30.0001 30.6292 29.3917 29.0978 28.3428C25.3006 30.147 22.5313 33.7554 21.9649 38.077C21.86 38.9582 22.5313 39.7134 23.4125 39.7134H45.6083C46.4894 39.7134 47.1817 38.9372 47.0558 38.077C46.4894 33.7554 43.7202 30.147 39.923 28.3428Z"
          fill="#00416B"
        />
        <path
          d="M41.3073 20.2449C41.3073 24.0002 38.2653 27.0631 34.4891 27.0631C30.7129 27.0631 27.6709 24.0212 27.6709 20.2449C27.6709 16.4687 30.7129 13.4268 34.4891 13.4268C38.2653 13.4268 41.3073 16.4687 41.3073 20.2449Z"
          fill="#00416B"
        />
      </g>
      <defs>
        <clipPath id="clip0_812_1037">
          <rect width="69" height="69" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
